import { AbstractContainerJobType } from "../enum/AbstractContainerJobType";
import { JobTypeEnum } from "../enum/JobTypeEnum";

export class AbstractContainerJobTypeHelper {

    memoDictionary: {
        [key: string]: {
            [key: string]: boolean;
        }
    } = {};

    readonly moveJobTypes: JobTypeEnum[] = [
        JobTypeEnum.MoveMt,
        JobTypeEnum.MoveFull,
    ];

    readonly outboundTypes: JobTypeEnum[] = [
        JobTypeEnum.Export,
        JobTypeEnum.DomesticOutbound,
        JobTypeEnum.RailOutbound
    ];

    readonly inboundTypes: JobTypeEnum[] = [
        JobTypeEnum.Import,
        JobTypeEnum.DomesticInbound,
        JobTypeEnum.RailInbound
    ];

    readonly exportTypes: JobTypeEnum[] = [
        JobTypeEnum.Export
    ];

    readonly importTypes: JobTypeEnum[] = [
        JobTypeEnum.Import
    ];

    readonly coastalTypes: JobTypeEnum[] = [
        JobTypeEnum.DomesticOutbound,
        JobTypeEnum.DomesticInbound,
        JobTypeEnum.IntermodalCoastal
    ];

    readonly railTypes: JobTypeEnum[] = [
        JobTypeEnum.RailOutbound,
        JobTypeEnum.RailInbound,
        JobTypeEnum.IntermodalRail
    ];

    readonly seaTypes: JobTypeEnum[] = [
        JobTypeEnum.Export,
        JobTypeEnum.Import,
        JobTypeEnum.DomesticOutbound,
        JobTypeEnum.DomesticInbound,
        JobTypeEnum.IntermodalCoastal
    ];

    readonly fullLegOnlyAvailableTypes: JobTypeEnum[] = [
        ...this.inboundTypes,
        ...this.outboundTypes,
        ...this.coastalTypes,
    ];
    readonly intermodalTypes: JobTypeEnum[] = [
        JobTypeEnum.IntermodalCoastal,
        JobTypeEnum.IntermodalRail
    ];

    readonly onSiteJobTypes: JobTypeEnum[] = [
        JobTypeEnum.OnSite
    ];

    private getMemoizedValue(checkType: string, value: JobTypeEnum | null, jobTypesToCheck: JobTypeEnum[]): boolean {
        if (value === null) {
            return false;
        }

        if (!this.memoDictionary[checkType]) {
            this.memoDictionary[checkType] = {};
        }
        if (this.memoDictionary[checkType][value] !== null && this.memoDictionary[checkType][value] !== undefined) {
            return this.memoDictionary[checkType][value];
        }
        this.memoDictionary[checkType][value] = this.calculateMemoizedValue(value, jobTypesToCheck);
        return this.memoDictionary[checkType][value];
    }

    calculateMemoizedValue(value: JobTypeEnum, jobTypesToCheck: JobTypeEnum[]): boolean {
        return jobTypesToCheck.includes(value);
    }

    isFullLegOnlyAvailable(jobType: JobTypeEnum | null): boolean {
        return this.getMemoizedValue('isFullLegOnlyAvailable', jobType, this.fullLegOnlyAvailableTypes);
    }

    isMoveJob(jobType: JobTypeEnum | null): boolean {
        return this.getMemoizedValue('isMoveJob', jobType, this.moveJobTypes);
    }

    isOutboundJob(jobType: JobTypeEnum | null): boolean {
        return this.getMemoizedValue('isOutboundJob', jobType, this.outboundTypes);
    }

    isInboundJob(jobType: JobTypeEnum | null): boolean {
        if (jobType === null) {
            return false;
        }
        return this.inboundTypes.includes(jobType);
    }

    isExportJob(jobType: JobTypeEnum | null): boolean {
        if (jobType === null) {
            return false;
        }
        return this.exportTypes.includes(jobType);
    }

    isImportJob(jobType: JobTypeEnum | null): boolean {
        if (jobType === null) {
            return false;
        }
        return this.importTypes.includes(jobType);
    }

    isCoastalJob(jobType: JobTypeEnum | null): boolean {
        if (jobType === null) {
            return false;
        }
        return this.coastalTypes.includes(jobType);
    }

    isRailJob(jobType: JobTypeEnum | null): boolean {
        if (jobType === null) {
            return false;
        }
        return this.railTypes.includes(jobType);
    }

    isSeaJob(jobType: JobTypeEnum | null): boolean {
        if (jobType === null) {
            return false;
        }
        return this.seaTypes.includes(jobType);
    }

    isIntermodalJob(jobType: JobTypeEnum | null): boolean {
        if (jobType === null) {
            return false;
        }
        return this.intermodalTypes.includes(jobType);
    }

    isOnSiteJob(jobType: JobTypeEnum | null): boolean {
        return this.getMemoizedValue('isOnSite', jobType, this.onSiteJobTypes);
    }

    getAllAbstractJobTypes(jobType: JobTypeEnum): AbstractContainerJobType[] {
        let abstractJobTypes: AbstractContainerJobType[] = [];

        if (this.isMoveJob(jobType)) {
            abstractJobTypes.push(AbstractContainerJobType.Move);
        }

        if (this.isOutboundJob(jobType)) {
            abstractJobTypes.push(AbstractContainerJobType.Outbound);
        }

        if (this.isInboundJob(jobType)) {
            abstractJobTypes.push(AbstractContainerJobType.Inbound);
        }

        if (this.isImportJob(jobType)) {
            abstractJobTypes.push(AbstractContainerJobType.Import);
        }

        if (this.isCoastalJob(jobType)) {
            abstractJobTypes.push(AbstractContainerJobType.Coastal);
        }

        if (this.isRailJob(jobType)) {
            abstractJobTypes.push(AbstractContainerJobType.Rail);
        }

        if (this.isSeaJob(jobType)) {
            abstractJobTypes.push(AbstractContainerJobType.Sea);
        }

        if (this.isIntermodalJob(jobType)) {
            abstractJobTypes.push(AbstractContainerJobType.Intermodal);
        }

        return abstractJobTypes;
    }

}
